import { useStaticQuery, graphql } from 'gatsby'

export const useNavigationQuery = () => {
  const header = useStaticQuery(graphql`
    query NavigationQuery {
      header: allFile(filter: { name: { eq: "header" } }) {
        nodes {
          childEnJson {
            logo
          }
          childUkJson {
            logo
          }
          sourceInstanceName
        }
      }

      example: allFile(filter: { name: { eq: "header.example" } }) {
        nodes {
          childEnJson {
            logo
          }
          childUkJson {
            logo
          }
          sourceInstanceName
        }
      }
    }
  `)

  if (header.header.nodes.length === 0) {
    return header.example.nodes
  }

  return header.header.nodes
}
